import React from "react";
import {EndSessionRequest} from "@azure/msal-browser";

export interface MainContext {
    inProgressApi: boolean;
    setInProgressApi?: React.Dispatch<React.SetStateAction<boolean>>;
    isAuthenticated: boolean;
    accessToken: string | null;
    username?: string;
    setAccessToken?: React.Dispatch<React.SetStateAction<string | null>>;
    sidebarIsOpen: boolean;
    setSidebarIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    //logoutAction?: (arg?: EndSessionRequest) => Promise<void>;
    logoutAction: () => void;
    doAcquireTokenRedirect: () => void;
    showMsg: (msg: string, detail?: string, severity?: "success" | "info" | "warn" | "error", sticky?: boolean) => void
}

const DEFAULT_CONTEXT_VALUE: MainContext = {
    inProgressApi: false,
    setInProgressApi: undefined,
    isAuthenticated: false,
    accessToken: null,
    username: "",
    sidebarIsOpen: false,
    setAccessToken: undefined,
    doAcquireTokenRedirect: () => { },
    showMsg: () => { },
    logoutAction: () => {}
};

export default React.createContext(DEFAULT_CONTEXT_VALUE);